import React, { useState } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import {
  message, Select, Icon, Menu, Dropdown, Button, Select as AntdSelect, Modal,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton,
} from 'konsys-ui'
import { useMutation } from '@apollo/react-hooks'
import { PURCHASE_REQUISITION_LIST } from '../../constants/graph/query'
import { CANCEL_PURCHASE_REQUISITION } from '../../constants/graph/mutation'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { P } from '../../pages/purchase-requisition-page/styled'
import { STATUS_VALUE } from '../../pages/purchase-requisition-page/constants'
import PERMISSION from '../../constants/permissions'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const { color } = theme

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={(e) => {
    handleChange(e.target.value)
  }} value={value} />
)

const CancelModal = ({
  original, setCancelModal, cancelModal, refetch,
}) => {
  const [doAction, { loading: mutationLoading }] = useMutation(CANCEL_PURCHASE_REQUISITION)
  return (
    <Modal
      title="ยกเลิกใบขอเสนอซื้อ"
      visible={cancelModal}
      destroyOnClose={true}
      okText='ยกเลิก'
      cancelText='เก็บไว้'
      onCancel={() => {
        setCancelModal(false)
      }}
      onOk={() => {
        doAction({
          variables: {
            id: original.id,
          },
          refetchQueries: [{
            query: PURCHASE_REQUISITION_LIST,
            variables: {
              limit: 5, offset: 0, orderField: 'updatedAt', orderBy: 'DESC',
            },
          }],
        }).then(({ data }) => {
          const KEY = 'DeletePurchaseRequest'
          if (data[KEY].success) {
            message.success(data[KEY].message)
          } else message.error(data[KEY].message)
        })
        setCancelModal(false)
      }}
      okButtonProps={{
        loading: mutationLoading,
        disabled: mutationLoading,
      }}
      cancelButtonProps={{
        disabled: mutationLoading,
      }}
    >
      <Div display='flex' flexDirection='row' alignItems='center' justifyContent='space-evenly' margin='0 0 16px'>
        <P>คุณต้องการยกเลิกใบขอเสนอซื้อหมายเลข {original.refId} </P>
      </Div>
    </Modal>
  )
}


const menu = (original, setCancelModal) => {
  const download = () => {
    window.open(
      `${getURL().FILE_SERVER}/render/pdf/pr/${original.id}?t=${getAccessToken()}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
  }
  return (
    <Div>
      <Menu selectedKeys={[null]} onSelect={(e) => { if (e.key === 'cancel') setCancelModal(true) }}>
        <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_PURCHASE_REQUISITION)}>
          <Link target="_blank" to={`/purchase-requisition/view/${original.id}`}>
            ดูรายละเอียด
          </Link>
        </Menu.Item>
        <Menu.Item key='print' disabled={!_.includes(window.perms, PERMISSION.VIEW_PURCHASE_REQUISITION)} onClick={() => {
          download()
        }}>
          พิมพ์ใบขอเสนอซื้อ
        </Menu.Item>
        <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_PURCHASE_REQUISITION) || original.status === STATUS_VALUE.COMPLETED}>
          <Link target="_blank" to={`/purchase-requisition/edit/${original.id}`}>
            แก้ไข
          </Link>
        </Menu.Item>
        {
          (original.status === 'WAITING' || original.status === 'LATED')
          && <Menu.Item key='cancel' disabled={!_.includes(window.perms, PERMISSION.UPDATE_PURCHASE_REQUISITION)}>
            ยกเลิก
          </Menu.Item>
        }
      </Menu>
    </Div>
  )
}

export const ActionSelector = ({ props: { original } }) => {
  const [cancelModal, setCancelModal] = useState(false)
  return (
    <Div>
      <Dropdown overlay={menu(original, setCancelModal)} trigger='click'>
        <Button>
          ดูรายละเอียด <Icon type="down" />
        </Button>
      </Dropdown>
      <CancelModal
        original={original}
        cancelModal={cancelModal}
        setCancelModal={setCancelModal}
      />
    </Div>
  )
}

export const DropdownSelector = ({
  data, handleChange, brand,
}) => {
  const width = brand ? '130px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
      {
        data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
      }
    </AntdSelect>
  )
}

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, disabled, refetch, setMutationVariables,
}) => (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_PURCHASE_REQUISITION)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          console.info(mutationVariables)
          if (isViewMode) history.push(`/purchase-requisition/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode
              ? {
                ...mutationVariables,
                Items: _.map(mutationVariables.Items, u => _.pick(u, ['inventoryOptionId', 'quantity', 'remark'])),
              }
              : {
                id: parseInt(props.match.params.id, 10),
                ...mutationVariables,
                Items: _.map(mutationVariables.Items, u => _.pick(u, ['inventoryOptionId', 'quantity', 'remark'])),
              },
              refetchQueries: [{
                query: PURCHASE_REQUISITION_LIST,
                variables: {
                  limit: 5, offset: 0, orderField: 'updatedAt', orderBy: 'DESC',
                },
              }],
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreatePurchaseRequest : data.UpdatePurchaseRequest // *
              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/purchase-requisition')
                // else {
                //   refetch()
                //   history.push(`/mechanic/view/${props.match.params.id}`)
                // }
              } else message.error(resp.message)
            })
          }
        }}
      />
    </Div>
)
